export default "/images/vendor/flag-icon-css/flags/4x3/gh.svg?d060e231aa94a98e78d96e709c1f9914";